export default __webpack_public_path__ + "static/media/14001_2015.ffcef229.pdf";